export default "__VITE_ASSET__CinNHGPm__"